import {
  Box,
  Button,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import {
  HeaderBreadcrumbs,
  ScreenError,
  ScreenWrap,
  SearchInput,
  SoloLoading,
} from '../../components';
import { Plus } from '@phosphor-icons/react';
import { Link } from 'react-router';
import useModifiableParams from '../../hooks/use-modifiable-params';
import { Api } from '../../api';

export default function ContentTagsListScreen() {
  const {
    getParams,
    setModifiedParams,
    tablePaginationProps,
    tableSortLabelProps,
  } = useModifiableParams();

  const params = getParams();

  const api = Api.Tag.useReadCollectionAll(params);

  if (api.error) return <ScreenError {...api} />;

  const tags = api.data?.member;

  return (
    <ScreenWrap>
      <Stack spacing={3} alignItems="stretch">
        <HeaderBreadcrumbs
          title="Content Tags"
          items={[{ name: 'Library Content', url: '/library' }]}
        />
        <Stack
          direction="row"
          alignItems="end"
          spacing={2}
          sx={{ width: '100%' }}
        >
          <SearchInput
            label="Search"
            value={params.internalName || ''}
            onChange={(e) =>
              setModifiedParams({ internalName: e.target.value, page: '1' })
            }
            placeholder="Search for tag"
          />
          <Box>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Plus />}
              component={Link}
              to="/library/content-tags/new"
            >
              Create
            </Button>
          </Box>
        </Stack>

        <Stack spacing={2}>
          <Card>
            {tags ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Tag</TableCell>
                      <TableCell>
                        <TableSortLabel
                          {...tableSortLabelProps('category.name')}
                        >
                          Category
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>User-Facing Label</TableCell>
                      <TableCell>Logic Slug</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tags.map((tag: Api.Tag.V) => (
                      <TableRow
                        component={Link}
                        to={`/library/content-tags/${tag.id}`}
                        key={tag.id}
                        sx={{
                          cursor: 'pointer',
                          textDecoration: 'none',
                          '&:hover': {
                            backgroundColor: 'action.hover',
                          },
                        }}
                      >
                        <TableCell>{tag.internalName}</TableCell>
                        <TableCell>{tag.category.name}</TableCell>
                        <TableCell>{tag.userFacingName}</TableCell>
                        <TableCell>
                          {tag.slug ? (
                            <span
                              style={{
                                display: 'inline-block',
                                background: '#eee',
                                borderRadius: 8,
                                padding: '2px 8px',
                                fontSize: 12,
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {tag.slug}
                            </span>
                          ) : (
                            '-'
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter
                    sx={{
                      borderTop: '1px solid rgba(224, 224, 224, 1)',
                    }}
                  >
                    <TableRow>
                      <TablePagination
                        {...tablePaginationProps({
                          totalItems: api.data?.totalItems ?? 0,
                          rowsPerPage: 10,
                        })}
                        count={api.data?.totalItems ?? 0}
                        colSpan={5}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            ) : (
              <SoloLoading />
            )}
          </Card>
        </Stack>
      </Stack>
    </ScreenWrap>
  );
}
